<template>
    <h4 class="mt-2" style="font-weight:200;">
        Here are some credit building offers for you
    </h4>
    <h2 class="mt-2">Your Recommendations</h2>
    <small class="text-start mb-2 mt-3" style="font-size:11px;display:block;" title="CompareHub by LoansCanada.cs">
        <i class="fa-solid fa-circle-info"></i> These recommendations are brought to you by CompareHub and generated using the information you provided in your request.
    </small>
    <div class="mt-4">
        <div class="card mx-3 my-5 best_credit_building">
            <img src="https://app.loanscanada.ca/assets/images/categories/best_credit_building.png" alt="Badge Best Credit Building" width="120" height="auto" class="badge-img">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-2" style="display: flex; justify-content: center; align-items: center; max-height: 150px;">
                        <img src="https://cmi.rocks/storage/partners/dmH03vrGyFcz1VRP3CzTuxeprGp3k1DAt5FbLPPA.png" alt="Kikoff logo" style="max-height:85px; max-width:200px; border-radius: 0;">
                    </div>
                    <div class="row">
                        <div class="col-md-10 offset-md-1">
                            <p class="h6 mt-4">
                                Kikoff users see an average 28 point increase after two months* - with no credit checks and no hidden fees! Plans start at $10/month.
                                <a href="https://cmi.rocks/go/6749f1e54d12c?source1=newform_refresh_page" target="_blank" class="btn btn-primary d-block mt-3 text-uppercase fw-bold">Get Started With Kikoff</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mx-3 my-5 best_credit_building">
            <img src="https://app.loanscanada.ca/assets/images/categories/best_credit_building.png" alt="Badge Best Credit Building" width="120" height="auto" class="badge-img">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-2" style="display: flex; justify-content: center; align-items: center; max-height: 150px;">
                        <img src="https://cmi.rocks/img/capitalone-mastercard.png" alt="Capital One logo" style="max-height:150px; max-width: 180px; border-radius: 7px;">
                    </div>
                    <div class="row">
                        <div class="col-md-10 offset-md-1">
                            <p class="h6 mt-4">
                                Use Capital One's Guaranteed Mastercard® to start building or rebuilding your credit history today. <a href="https://cmi.rocks/go/6500b385120c5?source1=newform_refresh_page" target="_blank" class="btn btn-primary d-block mt-3 text-uppercase fw-bold">Get This Card</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mx-3 my-5 best_guaranteed_approval">
            <img src="https://app.loanscanada.ca/assets/images/categories/best_guaranteed_approval.png" alt="Badge Best Guaranteed Approval" width="120" height="auto" class="badge-img">

            <div class="card-body">
                <div class="text-center">
                    <div class="mt-2" style="display: flex; justify-content: center; align-items: center; max-height: 150px;">
                        <img src="https://cmi.rocks/img/koho-cap.png" alt="KOHO logo" style="max-height:150px; max-width: 180px; border-radius: 7px;">
                    </div>
                    <div class="row">
                        <div class="col-md-10 offset-md-1">
                            <p class="h6 mt-4">
                                Your request has been matched with KOHO Cover. Get a cash advance of up to $250 interest free, no credit check required. <a href="https://cmi.rocks/go/662bcff825710?source1=newform_results_page&amp;state=QC" target="_blank" class="btn btn-primary d-block mt-3 text-uppercase fw-bold">Get Covered by KOHO</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mx-3 my-5 best_credit_building">
            <img src="https://app.loanscanada.ca/assets/images/categories/best_credit_building.png" alt="Badge Best Credit Building" width="120" height="auto" class="badge-img">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-2" style="display: flex; justify-content: center; align-items: center; max-height: 150px;">
                        <img src="https://cmi.rocks/storage/partners/Pd4BuvsfkbMddoGW3UQIf1Tcv7ikRDnxTKSDi7Z0.png" alt="Capital One logo" style="max-height:150px; max-width: 180px; border-radius: 7px;">
                    </div>
                    <div class="row">
                        <div class="col-md-10 offset-md-1">
                            <p class="h6 mt-4">
                                Use Spring Financial’s Foundation Loan to begin improving your financial health. <a href="https://loanscanada.ca/click?link_id=6744934e2a03f&source1=newform_refresh_page" target="_blank" class="btn btn-primary d-block mt-3 text-uppercase fw-bold">Apply Today</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mx-3 my-5 ">
            <div class="card-body">
                <div class="text-center">
                    <div class="mt-2" style="display: flex; justify-content: center; align-items: center; max-height: 150px;">
                        <img src="https://cmi.rocks/storage/partners/iqy69Bkpzd2TBN7kEb0P9cRqGOrgwTBWFa4cP2VN.png" alt="Free Credit Score by Loans Canada logo" style="max-height:85px; max-width:200px; border-radius: 7px;">
                    </div>
                    <div class="row">
                        <div class="col-md-10 offset-md-1">
                            <p class="h6 mt-4">
                                You can now obtain your Equifax credit score <b>instantly</b> and <b>free</b> with CompareHub. <a :href="'https://cmi.rocks/go/647f71c130b87?source1=newform_refresh_page&unique_id='+this.$parent.uid ?? ''" target="_blank"><b>Click here to create an account</b></a> and get your free score (this doesn't affect your credit!).
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HarcodedOffers',
    emits: ['selectedProduct'],
    props: {},
    data() {
        return {}
    },
    methods: {}
}
</script>
